var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibleOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 40,
    viewBox: "0 96 960 960",
    width: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M808 994.667 640 829.333q-35 13-76.166 19.834Q522.667 856 480 856q-147.667 0-266.333-82.167Q95 691.667 40 556q20.333-52.333 54.667-100.5 34.333-48.167 82-90.167L56 243.999l46.666-47.333 750.001 750.001-44.667 48ZM480 729.333q13 0 26.834-2 13.833-2 24.833-6.333L315 504.333q-4.333 11.667-6.333 24.834-2 13.166-2 26.833 0 73 50.833 123.167 50.833 50.166 122.5 50.166ZM762.666 762 634.333 634q9-16.333 14-36.5t5-41.5q0-72.333-50.5-122.833T480 382.667q-21.333 0-41.167 4.667Q419 392 402 402L294.666 294q37-16.333 87.667-27.167Q433 256 483.333 256q145.667 0 264 82.167Q865.667 420.333 920 556q-25 62.333-64.833 114.5-39.834 52.167-92.501 91.5ZM585.667 585.334 451 450.667q28.666-9 57.166-1.5 28.501 7.499 49.501 28.166 21 21.334 29.5 48.167 8.5 26.833-1.5 59.834Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibleOff);
export default __webpack_public_path__ + "static/media/visibleOff.e0fb3516051f2fa724b88f8db7a92b5c.svg";
export { ForwardRef as ReactComponent };